export function extractEditorContent(html) {
  const doc = new DOMParser().parseFromString(html ?? '', 'text/html');
  doc.body.querySelector('[data-template-header]')?.remove();
  doc.body.querySelector('[data-template-disclosures]')?.remove();
  doc.body.querySelector('[data-template-sender]')?.remove();
  let emailBody = doc.body.querySelector('.email-body');
  while (emailBody?.querySelector('.email-body')) {
    emailBody = emailBody.querySelector('.email-body');
  }
  return emailBody ? emailBody.innerHTML : doc.body.innerHTML;
}

// Marks the <style> block that carries a template's own (non-shell) CSS so it can be
// found again on the next edit round-trip instead of being re-derived from scratch.
export const CUSTOM_STYLE_MARKER = 'data-custom-template-css';

// Pulls balanced top-level at-rule blocks (@media / @supports / @font-face / @keyframes)
// out of a raw CSS string. Brace-matched rather than regex-based so nested rules inside a
// media query are captured intact. Plain rules are intentionally skipped — those are
// re-emitted from the app's EMAIL_STYLES shell on save.
function extractAtRuleBlocks(css) {
  const source = String(css ?? '');
  const blocks = [];
  const KEEP = /^@(media|supports|font-face|keyframes|-webkit-keyframes)\b/i;

  let i = 0;
  while (i < source.length) {
    const at = source.indexOf('@', i);
    if (at === -1) break;
    const braceOpen = source.indexOf('{', at);
    if (braceOpen === -1) break;

    let depth = 0;
    let j = braceOpen;
    for (; j < source.length; j += 1) {
      const ch = source[j];
      if (ch === '{') depth += 1;
      else if (ch === '}') {
        depth -= 1;
        if (depth === 0) {
          j += 1;
          break;
        }
      }
    }

    const prelude = source.slice(at, braceOpen).trim();
    if (KEEP.test(prelude)) blocks.push(source.slice(at, j).trim());
    i = j;
  }

  return blocks;
}

// Preserves the responsive / custom CSS carried by migrated (e.g. MJML) email templates,
// which the shell rebuild (buildEmailShell) would otherwise drop. Returns a CSS string to be
// re-attached on save, or '' when the template has no custom rules (the common case for
// templates authored in-app).
export function extractCustomStyle(html) {
  const doc = new DOMParser().parseFromString(html ?? '', 'text/html');

  // Templates already saved through our shell carry their custom CSS in a marked <style>.
  const marked = doc.querySelector(`style[${CUSTOM_STYLE_MARKER}]`);
  if (marked) return (marked.textContent ?? '').trim();

  // First time we see a raw/migrated document: keep only its at-rule blocks. Plain shell
  // rules are excluded so they don't duplicate — and eventually fight — EMAIL_STYLES.
  const blocks = [];
  doc.querySelectorAll('style').forEach((styleEl) => {
    blocks.push(...extractAtRuleBlocks(styleEl.textContent ?? ''));
  });
  return blocks.join('\n').trim();
}
